import {
  applySnapshot,
  getSnapshot,
  Instance,
  SnapshotIn,
  types,
} from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';

export interface SimilarTransactionsProps {
  similar: number;
  status: LoadingState;
}

export const SimilarTransactions = types
  .model({
    similar: types.maybe(types.number),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: SimilarTransactionsProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }));

export type SimilarTransactionsSnapshot = SnapshotIn<
  typeof SimilarTransactions
>;
export type SimilarTransactionsInstance = Instance<typeof SimilarTransactions>;
